import React from "react";
import { Button } from "src/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/components/ui/select";
import { ChevronsLeft, ChevronLeft, ChevronRight, ChevronsRight } from "lucide-react";

interface TablePaginationProps {
  currentPage: number;
  totalPages: number;
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
  limit: 10 | 25 | 50 | 100 | 200;
  onLimitChange: (value: 10 | 25 | 50 | 100 | 200) => void;
  disabled?: boolean;
  selectDisabled?: boolean;
  pageText?: string;
  selectSide?: "top" | "bottom";
}

const TablePagination: React.FC<TablePaginationProps> = ({
  currentPage,
  totalPages,
  onFirst,
  onPrev,
  onNext,
  onLast,
  limit,
  onLimitChange,
  disabled,
  selectDisabled,
  pageText,
  selectSide = "bottom",
}) => (
  <div className="flex items-center gap-2">
    <div className="flex items-center gap-1">
      <Button
        variant="outline"
        size="sm"
        onClick={onFirst}
        disabled={currentPage === 1 || disabled}
        className="h-7 w-7 p-0"
        aria-label="First page"
      >
        <ChevronsLeft className="w-3 h-3" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onPrev}
        disabled={currentPage === 1 || disabled}
        className="h-7 w-7 p-0"
        aria-label="Previous page"
      >
        <ChevronLeft className="w-3 h-3" />
      </Button>
      <span className="text-xs text-muted-foreground min-w-[72px] text-center">{pageText || `Page ${currentPage}/${totalPages}`}</span>
      <Button
        variant="outline"
        size="sm"
        onClick={onNext}
        disabled={currentPage >= totalPages || disabled}
        className="h-7 w-7 p-0"
        aria-label="Next page"
      >
        <ChevronRight className="w-3 h-3" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onLast}
        disabled={currentPage >= totalPages || disabled}
        className="h-7 w-7 p-0"
        aria-label="Last page"
      >
        <ChevronsRight className="w-3 h-3" />
      </Button>
    </div>
    <Select
      value={`${limit}`}
      onValueChange={(value) => onLimitChange(parseInt(value, 10) as 10 | 25 | 50 | 100 | 200)}
      disabled={selectDisabled}
    >
      <SelectTrigger className="h-7 w-16 text-xs" disabled={selectDisabled}>
        <SelectValue placeholder={`${limit}`} />
      </SelectTrigger>
      <SelectContent side={selectSide}>
        {[10, 25, 50, 100, 200].map((size) => (
          <SelectItem key={size} value={`${size}`}>
            {size}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export default TablePagination;
